import { MdLocalShipping, MdFlashOn } from "react-icons/md";
import { getFeatureIcon, formatPrice, getDeliverySummary } from "./productUtils";

// Ürünün mağaza sayfasında nasıl görüneceğinin küçültülmüş önizlemesi.
const ProductPreview = ({ product }) => {
	const features = (product.productFeatures || []).filter(
		(f) => f.title || f.description
	);
	const specs = (product.productSpecs || []).filter((s) => s && s.trim());
	const delivery = getDeliverySummary(product);
	const DeliveryIcon = product.productType === "instant" ? MdFlashOn : MdLocalShipping;

	return (
		<div className="product-preview">
			<div className="product-preview-top">
				<div className="product-preview-image">
					{product.productImage ? (
						<img src={product.productImage} alt={product.productName} />
					) : (
						<span>Görsel yok</span>
					)}
				</div>
				<div className="product-preview-info">
					<h2>{product.productName || "Ürün Adı"}</h2>
					<p className="product-preview-desc">
						{product.productDescription || "Ürün açıklaması burada görünecek."}
					</p>
					{features.map((feature, index) => {
						const Icon = getFeatureIcon(feature.icon);
						return (
							<div className="product-preview-feature" key={index}>
								<div className="product-preview-feature-icon">
									<Icon />
								</div>
								<div>
									<strong>{feature.title}</strong>
									<p>{feature.description}</p>
								</div>
							</div>
						);
					})}
					<div className="product-preview-price">
						<span>{formatPrice(product.productPrice, product.productCurrency)}</span>
						<div className="product-preview-qty">
							<button type="button">-</button>
							<input value="1" readOnly />
							<button type="button">+</button>
						</div>
						<button type="button" className="product-preview-cart">
							Sepete Ekle
						</button>
					</div>
					<div className="product-preview-delivery">
						<DeliveryIcon />
						<div>
							<strong>{delivery.title}</strong>
							{delivery.lines.map((line, index) => (
								<p key={index}>{line}</p>
							))}
						</div>
					</div>
				</div>
			</div>
			{specs.length > 0 && (
				<div className="product-preview-specs">
					<h3>Teknik Özellikler</h3>
					<ul>
						{specs.map((spec, index) => (
							<li key={index}>{spec}</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default ProductPreview;
